<template>
	<section class="flex items-center">
		<router-link 
			v-for="(item, i) in navMenuItems"
			class="text-white p-4" :to="item.url"
		>
			<small><strong class="hover:m-2">{{item.name}}</strong></small>
		</router-link>
	</section>
</template>
<script type="text/javascript">
import navMenuItems from '@/layouts/components/vertical-nav-menu/navMenuItems.js'

export default {
  data: () => ({
    navMenuItems
  })
}
</script>